import api from "../api/api";

export const createOrder = async (orderData) => {
  try {
    const response = await api.post("ecommerce/orders", orderData);
    return response.data;
  } catch (error) {
    console.error("Failed to create order:", error);
    throw error;
  }
};

export const uploadPaymentSlip = async (orderId, slipFile) => {
  try {
    const formData = new FormData();
    formData.append('payment_slip', slipFile);
    formData.append('_method', 'PUT');

    const response = await api.post(`ecommerce/orders/${orderId}/upload-slip`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to upload payment slip:", error);
    throw error;
  }
};

export const getOrderStatus = async (orderId) => {
  try {
    const response = await api.get(`ecommerce/orders/${orderId}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch order status:", error);
    throw error;
  }
};